(() => {
  const selectors = {
    product: "[data-product-id]",
    productJson: "[data-product-json]",
    variantInput: 'product-form input[name="id"], .js-product-form input[name="id"]',
    price: ".product-detail__price .theme-money.large-title",
    comparePrice: ".product-detail__price .product-price__compare.theme-money"
  };

  const readAddonCents = (product) => {
    const text = product.innerText || "";
    const match = text.match(/Selections will add\s+([^\n\r]+?)\s+to the price/i);
    if (!match) return 0;

    const numberMatch = match[1].match(/[\d.,]+/);
    if (!numberMatch) return 0;

    let value = numberMatch[0];
    const lastComma = value.lastIndexOf(",");
    const lastDot = value.lastIndexOf(".");
    const decimalIndex = Math.max(lastComma, lastDot);

    if (decimalIndex >= 0 && value.length - decimalIndex - 1 <= 2) {
      const whole = value.slice(0, decimalIndex).replace(/[^\d]/g, "") || "0";
      const fraction = value.slice(decimalIndex + 1).replace(/[^\d]/g, "").padEnd(2, "0").slice(0, 2);
      return Number.parseInt(whole, 10) * 100 + Number.parseInt(fraction, 10);
    }

    return Number.parseInt(value.replace(/[^\d]/g, ""), 10) * 100;
  };

  const formatMoney = (cents) => {
    const themeObject = window.theme;
    const format = themeObject && (themeObject.moneyFormatWithCodeForProductsPreference || themeObject.moneyFormat);

    if (themeObject && themeObject.Shopify && typeof themeObject.Shopify.formatMoney === "function" && format) {
      return themeObject.Shopify.formatMoney(cents, format);
    }

    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency
    }).format(cents / 100);
  };

  const readProductData = (product) => {
    const productId = String(product.dataset.productId || "").replace("gid://shopify/Product/", "");
    const jsonElements = [
      product.querySelector(selectors.productJson),
      ...document.querySelectorAll(selectors.productJson)
    ].filter(Boolean);

    for (const json of jsonElements) {
      try {
        const productData = JSON.parse(json.textContent);
        if (!productId || String(productData.id) === productId) return productData;
      } catch (error) {
        continue;
      }
    }

    return null;
  };

  const updateProductTotal = (product) => {
    const price = product.querySelector(selectors.price);
    const variantInput = product.querySelector(selectors.variantInput);
    const productData = readProductData(product);
    if (!price || !variantInput || !productData || !Array.isArray(productData.variants)) return;

    const variant = productData.variants.find((item) => String(item.id) === String(variantInput.value));
    if (!variant || typeof variant.price !== "number") return;

    const addonCents = readAddonCents(product);
    const totalCents = variant.price + addonCents;
    const totalText = formatMoney(totalCents);

    if (price.textContent.trim() !== totalText) price.textContent = totalText;
    price.dataset.kbdAddonAmount = String(addonCents);

    const comparePrice = product.querySelector(selectors.comparePrice);
    if (comparePrice && typeof variant.compare_at_price === "number" && variant.compare_at_price > variant.price) {
      const compareText = formatMoney(variant.compare_at_price + addonCents);
      if (comparePrice.textContent.trim() !== compareText) comparePrice.textContent = compareText;
    }
  };

  let updateTimer;
  const scheduleUpdate = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(() => {
      document.querySelectorAll(selectors.product).forEach(updateProductTotal);
    }, 40);
  };

  document.addEventListener("change", scheduleUpdate, true);
  document.addEventListener("input", scheduleUpdate, true);
  document.addEventListener("on:variant:change", scheduleUpdate, true);

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }
})();
